a.location.display = (function(){
	var my = {
		popup:function(o){
			var o = o || {};
			var lid = o.lid || null;
			var f_close = o.close || function(){};
			/*Create popup*/
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Display location',
				winbar_action_icon:'trash',
				winbar_action:function(){
					if (confirm('This will delete the location. Proceed?')) {
						my.deleteLocation(lid,function(){
							window.history.back();
							f_close();
						});
					}
				},
				ready:function(token){
					// Hide delete button if no permsision
					if (a.s.ac.allow('content','location')=='false') {
						$('#popupid_'+token+' .popupwinbar>.action>i').hide();
					}
					// Load content
					my.loadInitContent(token,lid,f_close);
				}
			});
		},
		loadInitContent:function(token,lid,f_close){
			// Load item
			$.ajax({
				type:'GET',
				url:'/api/location/load/',
				data:{
					id:lid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						// Show content
						tpl.run({
							tpl:'/tpl/location/display/popup.ejs?v='+v,
							data:result,
							cb:function(c){
								$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
									// Bind save button
									$('#popupid_'+token+' button[data-action="save"]').unbind('click').click(function(){
										my.saveLocation(token,lid,function(){
											window.history.back();
											f_close();
										});
									});
								});
							}
						});
					}
					else {
						a.s.growl.create('Error','Unable to perform operation',{});
					}
				}
			});
		},
		saveLocation:function(token,lid,cb){
			if (a.s.ac.allow('content','location')) {
				var form = $('#popupid_'+token+' form[name="edit_location"]');
				// Data
				var data = form.serializeJSON();
				data.id = lid;
				data.token = localStorage.getItem('token');
				data.accountname = localStorage.getItem('accountname');
				$.ajax({
					type:'POST',
					url:'/api/location/save/',
					data:data,
					dataType:'json',
					cache: false,
					success:function(result) {
						if (result.success) {
							a.s.growl.create('Success','Location details was saved',{});
							cb();
						}
						else {
							a.s.growl.create('Error','Unable to save location',{});
						}
					}
				});
			}
			else {
				a.s.growl.create('Error','Unable to delete location',{});
			}
		},
		deleteLocation:function(lid,cb){
			if (a.s.ac.allow('content','location')) {
				$.ajax({
					type:'POST',
					url:'/api/location/delete/',
					data:{
						id:lid,
						token:localStorage.getItem('token'),
						accountname:localStorage.getItem('accountname')
					},
					dataType:'json',
					cache: false,
					success:function(result) {
						if (result.success) {
							a.s.growl.create('Success','Location was deleted',{});
							cb();
						}
						else {
							a.s.growl.create('Error','Unable to delete location',{});
						}
					}
				});
			}
			else {
				// Disallowed
			}
		}
	}
	return my;
}());